import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AriaLabelDirective } from 'src/app/shared/directives/aria-label.directive';
import { toSignal } from '@angular/core/rxjs-interop';
import { ChatButtonService } from 'src/app/core/services';
import { ChatHandler } from 'src/app/core/handler/chat-handler';

@Component({
  selector: 'app-chat-button',
  imports: [
    AriaLabelDirective,
    MatIcon,
  ],
  templateUrl: './chat-button.html',
  styleUrl: './chat-button.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatButton implements OnInit, OnDestroy {
  private chatButtonService = inject(ChatButtonService);
  private chatHandler = inject(ChatHandler);

  buttonVisibility = toSignal(this.chatButtonService.buttonVisibility$, { initialValue: false });
  isChatButtonHidden = toSignal(this.chatButtonService.isChatButtonHidden$, { initialValue: false });

  openChat() {
    this.chatHandler.openAsappChat();
  }
  
  ngOnInit(): void {
    this.chatButtonService.initialize();
  }

  ngOnDestroy(): void {
    this.chatButtonService.destroy();
  }
}
